export const APP_STORE_BADGE_SIZES = [{ id: 'md', value: '', minVw: '0px' }];

export const APP_STORES = Object.freeze({
  google: 'google',
  apple: 'apple',
  unknown: 'unknown'
});
